export default {
  theme: "flat" as "flat" | "stripe" | "night" | undefined,
  variables: {
    fontFamily: '"Aeonik", sans-serif',
    fontLineHeight: "1.5",
    borderRadius: "10px",
    colorBackground: "#F6F8FA",
    colorPrimaryText: "#262626",
  },
  rules: {
    ".Block": {
      backgroundColor: "var(--colorBackground)",
      boxShadow: "none",
      padding: "12px",
    },
    ".Input": {
      padding: "16px",
      border: "1px solid #16114F",
      boxShadow: "2px 2px 0px 0px #16114F",
      backgroundColor: "white",
    },
    ".Input:focus": {
      boxShadow: "2px 2px 0px 0px #16114F",
    },
    ".Input:disabled, .Input--invalid:disabled": {
      color: "lightgray",
    },
    ".Label": {
      fontWeight: "500",
    },
  },
};
